

const getGooglePayAddress = shippingAddress => {
    if (shippingAddress === null) {
        return {};
    }
    let line1 = "";
    let line2 = "";

    if (shippingAddress.addressLine.length > 0) {
        line1 = shippingAddress.addressLine[0];
    }

    if (shippingAddress.addressLine.length > 1) {
        line2 = shippingAddress.addressLine[1];
    }
    return {
        address: {
            line1,
            line2,
            city: shippingAddress.city,
            country: shippingAddress.country,
            postal_code: shippingAddress.postalCode
        },
        name: shippingAddress.recipient
    }
}


const addOnPaymentRequestReceived = (stripe,clientSecret, paymentRequest, onSuccess, showError) => {


    paymentRequest.on('paymentmethod', async ev => {     

        let shippingAddress = {};


        if (ev.methodName === "google-pay") {
            shippingAddress = getGooglePayAddress(ev.shippingAddress);
        } else if (ev.methodName === "apple-pay") {
            shippingAddress = getGooglePayAddress(ev.shippingAddress);
        } else if (ev.methodName === "link") {
            shippingAddress = getGooglePayAddress(ev.shippingAddress);
        }
        else {
            console.error("payment method not recognised");
        }

        // Confirm the PaymentIntent without handling potential next actions (yet).
        const { paymentIntent, error: confirmError } =
            await stripe.confirmCardPayment(
                clientSecret,
                {
                    payment_method: ev.paymentMethod.id,
                    shipping: shippingAddress
                },
                { handleActions: false }
            );

        if (confirmError) {
            // Report to the browser that the payment failed, prompting it to
            // re-show the payment interface, or show an error message and close
            // the payment interface.
            ev.complete('fail');
        } else {
            // Report to the browser that the confirmation was successful, prompting
            // it to close the browser payment method collection interface.
            ev.complete('success');

            // Check if the PaymentIntent requires any actions and if so let Stripe.js
            // handle the flow. If using an API version older than "2019-02-11"
            // instead check for: `paymentIntent.status === "requires_source_action"`.
            if (paymentIntent.status === "requires_action") {
                // Let Stripe.js handle the rest of the payment flow.
                const { error } = await stripe.confirmCardPayment(clientSecret);
                if (error) {
                    showError("Payment failed");
                    // The payment failed -- ask your customer for a new payment method.
                } else {
                    onSuccess();
                }
            } else {
                onSuccess();
            }
        }
    });
}

export default addOnPaymentRequestReceived;